import classes from "./CardAddBase.module.scss";
import CardBase from "../../../UI/Card/CardBase/CardBase";
import { useTranslation } from "react-i18next";

const CardAddBase = ({ children = null, subtitle }) => {
  const { t } = useTranslation();
  return (
    <CardBase classPrimary={classes.CardAddBase}>
      <div className={classes.Title}>
        { t("purchase.boots_your_tuning_plan")}
      </div>
      {/* <div className={classes.TitleLeft}>{ t("purchase.current_plan")}</div> */}
      <div className={classes.SubTitle}>{subtitle}</div>
      <div className={classes.Card}>{children}</div>
    </CardBase>
  );
};
export default CardAddBase;
